import {gql} from '@apollo/client';
import {PopReviewStatus, PopReviewType} from '../types/PopReviewType';

/**
 * POP 审核工作台列表（分页 + 多筛选）
 *
 * 与 api-server `PopReviewQuery.getPopReviewPageList` 对应：参数为扁平的
 * filters / page / size；工作台 Tab 以 filters.isFinished 传入。
 */

/** 后端 PopReviewFiltersTypeInput；时间为 ISO-8601 字符串，from 含、to 不含 */
export interface PopReviewFiltersTypeInput {
    reviewTaskId?: string;
    /** 是否已完结；对应工作台 Tab（新标记 false / 已终止 true） */
    isFinished?: boolean;
    statuses?: PopReviewStatus[];
    appointmentNumbers?: string;
    pickupHubId?: string;
    pickupSiteId?: string;
    driverId?: string;
    disqualifyReasonCodes?: string[];
    submittedAtFrom?: string;
    submittedAtTo?: string;
    reviewedAtFrom?: string;
    reviewedAtTo?: string;
}

export const POP_REVIEW_ITEM_FIELDS = gql`
    fragment PopReviewItemFields on PopReviewItemType {
        reviewTaskId
        status
        submittedAt
        slaDueAt
        reviewerId
        reviewer {
            name
        }
        reviewedAt
        updatedAt
        popReviewId
        appointmentId
        appointmentNumber
        pickupHubId
        pickupHubName
        pickupSiteId
        driverId
        driverName
        actualParcelCount
        pickupFailureReasonCode
        popPhotoCount
        pickupGpsLatitude
        pickupGpsLongitude
        pickupGpsAt
        pickupSiteDistanceMeters
        pickupDetail {
            siteName
            contactPhone
            channelId
            channelName
            address
            zipcode
            timezone
            source
            isNewWarehouse
            routeName
            taskNumber
            pickupStatus
            expectedPickupDate
            expectedPickupTimeStart
            updatedAt
        }
        disqualifyReasonCodes
        reviewRemark {
            text
            lang
            translations {
                lang
                text
            }
        }
    }
`;

export const GET_POP_REVIEW_PAGE_LIST = gql`
    ${POP_REVIEW_ITEM_FIELDS}
    query GetPopReviewPageList($filters: PopReviewFiltersTypeInput, $page: Int! = 1, $size: Int! = 20) {
        getPopReviewPageList(filters: $filters, page: $page, size: $size) {
            content {
                ...PopReviewItemFields
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface GetPopReviewPageListResponse {
    getPopReviewPageList: {
        content: PopReviewType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetPopReviewPageListInput {
    filters?: PopReviewFiltersTypeInput;
    page?: number;
    size?: number;
}
